/**
 * Utility function to convert textarea inputs to voiceTextarea based on component ID
 * This is used for components that need voice input capabilities
 */

/**
 * Converts textarea inputs to voiceTextarea for specific component IDs
 * @param config - The form configuration object
 * @returns The modified config object
 */

// config was of type 'any' in all the components, so using the same here
export function convertToVoiceTextarea(config: any): any {
  if (!config?.config?.componentId) {
    return config;
  }

  const componentId = config.config.componentId;
  const voiceTextareaComponents = [
    "narrativesCard",
    "notes",
    "coordinationOfCare",
    "situationalNotes",
  ];

  if (voiceTextareaComponents.includes(componentId)) {
    config.config.inputs.description.type = "voiceTextarea";
  }

  return config;
}



// WEBPACK FOOTER //
// ./src/utils/convert-to-voice-textarea.ts